import {Log} from '@aboutyou/mlm';
import {SERVER_RENDERING_MODE} from '@aboutyou/utils/server-rendering-modes';

import {assert} from 'ts-essentials';

export async function initializeServerRenderingMode() {
  assert(
    process.browser,
    'Expected initializeServerRenderingMode to be called on the client only',
  );

  const serverRenderingModeConfig = getServerRenderingModeConfig(document.body);

  assert(
    serverRenderingModeConfig,
    "Expected the server rendering mode config to be available in the client's initial markup. " +
      'Make sure it is provided via the server rendering code',
  );

  window.__SERVER_RENDERING_MODE__ =
    serverRenderingModeConfig.serverRenderingMode;
}

function getServerRenderingModeConfig(container: Element) {
  const serverRenderingModeElement = container.querySelector(
    '[data-server-rendering-mode]',
  );

  if (!serverRenderingModeElement) {
    return false;
  }

  try {
    return JSON.parse(serverRenderingModeElement.innerHTML);
  } catch (error) {
    Log.error(
      '@aboutyou/bootstrap',
      `Error parsing server rendering mode config:`,
      {error},
    );

    return null;
  }
}

export function getServerRenderingModeOnClient(): SERVER_RENDERING_MODE {
  return window.__SERVER_RENDERING_MODE__ ?? SERVER_RENDERING_MODE.SSR;
}
